import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlertComponent, PlessAlert } from './../../../../shared/pless-alert/pless-alert.component';
import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * アイテム情報取得クラス
 *
 * @export RegistGoodsService
 * @class RegistGoodsService
 * @extends {PlessResponder}
 */
@Injectable()
export class RegistGoodsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  private mode: string;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistGoodsService
   */
  private getBody(): PlessRequest {
    if ((PlessViewUtilsSub.isEmpty(this.vo.pCodeInfoVO.pCode))) {
      this.mode = 'regist';
    } else {
      this.mode = 'update';
    }

    // マークタブ情報
    const markCodes = this.vo.pCodeInfoVO.markInfoVO.markCodeList
      .filter(markCode => markCode.Check)
      .map(markCode => ({
        condition: {
            MarkCode: markCode.MarkCode
        }
      }));

    // 付加タブ情報
    const textInfos = this.vo.pCodeInfoVO.additionInfoVO.textInfoList
      .map(textInfo => ({
        condition: {
          TextKindId: textInfo.TextKindID,
          TextKindNum: 1,
          SelectedFlag: 1,
          StringValue: textInfo.StringValue
        }
      }));

    // 表組タブ情報
    const goodsListings = this.vo.pCodeInfoVO.goodsListingVO.goodsListingList
      .map(goodsListing => ({
        condition: {
          ListingItemId: goodsListing.ListingItemID,
          DispContents: goodsListing.DispContents,
        }
      }));

    // 利用生協タブ情報
    const goodsCoops = this.vo.itemInfoVO.useCoopVO.useCoopInfoList
      .map(coopInfo => {
        return coopInfo.Check ?
          {
            condition: {
              CoopCode: coopInfo.CoopCode,
              SelectedFlag: 1,
              SupplyPriceStandard: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceStandard)),
              SupplyPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial1)),
              SupplyPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial2)),
              CostPriceStandard: this.getCoopiInfoPrice(String(coopInfo.CostPriceStandard)),
              CostPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial1)),
              CostPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial2)),
              ConsignPriceStandard: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceStandard))),
              ConsignPriceSpecial1: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceSpecial1))),
              ConsignPriceSpecial2: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceSpecial2))),
              ProducingAreaComment1: coopInfo.ProducingAreaComment1,
              ProducingAreaComment2: coopInfo.ProducingAreaComment2,
              SupplyTaxWithoutStd: null,
              SupplyTaxWithoutSpc1: null,
              SupplyTaxWithoutSpc2: null
            }
          } :
          {
            condition: {
              CoopCode: coopInfo.CoopCode,
              SelectedFlag: 0,
              SupplyPriceStandard: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceStandard)),
              SupplyPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial1)),
              SupplyPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial2)),
              CostPriceStandard: this.getCoopiInfoPrice(String(coopInfo.CostPriceStandard)),
              CostPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial1)),
              CostPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial2)),
              ConsignPriceStandard: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceStandard))),
              ConsignPriceSpecial1: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceSpecial1))),
              ConsignPriceSpecial2: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceSpecial2))),
              ProducingAreaComment1: coopInfo.ProducingAreaComment1,
              ProducingAreaComment2: coopInfo.ProducingAreaComment2,
              SupplyTaxWithoutStd: null,
              SupplyTaxWithoutSpc1: null,
              SupplyTaxWithoutSpc2: null
            }
          }
      });

    // 利用生協タブ情報
    const goodsCoopWks = this.vo.itemInfoVO.useCoopVO.useCoopInfoListWk
      .map(coopInfo => {
        return coopInfo.Check ?
          {
            condition: {
              CoopCode: coopInfo.CoopCode,
              SelectedFlag: 1,
              SupplyPriceStandard: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceStandard)),
              SupplyPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial1)),
              SupplyPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial2)),
              CostPriceStandard: this.getCoopiInfoPrice(String(coopInfo.CostPriceStandard)),
              CostPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial1)),
              CostPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial2)),
              ConsignPriceStandard: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceStandard))),
              ConsignPriceSpecial1: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceSpecial1))),
              ConsignPriceSpecial2: this.getCoopiInfoPrice(String(Number(coopInfo.CostPriceSpecial2))),
              SupplyTaxWithoutStd: null,
              SupplyTaxWithoutSpc1: null,
              SupplyTaxWithoutSpc2: null
            }
          } :
          {
            condition: {
              CoopCode: coopInfo.CoopCode,
              SelectedFlag: 0,
              SupplyPriceStandard: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceStandard)),
              SupplyPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial1)),
              SupplyPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.SupplyPriceSpecial2)),
              CostPriceStandard: this.getCoopiInfoPrice(String(coopInfo.CostPriceStandard)),
              CostPriceSpecial1: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial1)),
              CostPriceSpecial2: this.getCoopiInfoPrice(String(coopInfo.CostPriceSpecial2)),
              ConsignPriceStandard: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceStandard))),
              ConsignPriceSpecial1: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceSpecial1))),
              ConsignPriceSpecial2: this.getCoopiInfoPrice(String(Number(coopInfo.ConsignPriceSpecial2))),
              SupplyTaxWithoutStd: null,
              SupplyTaxWithoutSpc1: null,
              SupplyTaxWithoutSpc: null
            }
          }
      });

    // 仕様書1タブ情報
    const specifications1s = this.vo.itemInfoVO.specifications1VO.specifications1List
      .map(specifications1Info => ({
        condition: {
          TextKindId: specifications1Info.TextInfoDiv,
          TextKindNum: 1,
          SelectedFlag: 1,
          StringValue: specifications1Info.StringValue
        }
      }));

    // 仕様書2タブ情報(表示アレルゲン・含有アレルゲン)
    // 表示アレルゲン
    const goodsAllergens = this.vo.itemInfoVO.specifications2VO.goodsAllergenList
      .filter(allergenInfo => allergenInfo.Check)
      .map(allergenInfo => ({
        condition: {
          AllergenDiv: allergenInfo.AllergenCode
        }
      }));
    // 含有アレルゲン
    const goodsComponentAllergens = this.vo.itemInfoVO.specifications2VO.goodsAllergenList
      .filter(allergenInfo => allergenInfo.ComponentCheck)
      .map(allergenInfo => ({
        condition: {
          AllergenDiv: allergenInfo.AllergenCode
        }
      }));

    // 環境関連タブ情報(環境配慮商品)
    const goodsEcologys = this.vo.itemInfoVO.ecologyVO.goodsEcologyList
      .filter(ecologyInfo => ecologyInfo.Check)
      .map(ecologyInfo => ({
        condition: {
          EcologyDiv: PlessViewUtilsSub.trim(String(ecologyInfo.EcologyDiv))
        }
      }));

    // 環境関連タブ情報(温暖化防止)
    const goodsGWStops = this.vo.itemInfoVO.ecologyVO.goodsGWStopList
      .filter(gwStopInfo => gwStopInfo.Check)
      .map(gwStopInfo => ({
        condition: {
          GWStopGoodsDiv: gwStopInfo.GWStopDiv
        }
      }));

    // 環境関連タブ情報(容器包装材)
    const containPackings =this.vo.itemInfoVO.ecologyVO.containPackingList
      .filter(packingInfo => packingInfo.Check)
      .map(packingInfo => ({
        condition: {
          ContainDiv: packingInfo.ContainDiv,
          ContainKind: packingInfo.ContainKind,
          PackMaterialWeight: packingInfo.PackMaterialWeight
        }
      }));

    // 商品仕様書マスタ情報
    const goodsSpecificationInfo = this.vo.itemInfoVO.goodsSpecificationInfoVO ?
      {
        condition: {
          PieceSizeLength: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceSizeLength,
          PieceSizeWidth: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceSizeWidth,
          PieceSizeHeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceSizeHeight,
          PieceWeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceWeight,
          PieceContainNum: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceContainNum,
          PieceJanCode: this.vo.itemInfoVO.goodsSpecificationInfoVO.pieceJanCode,
          PackSizeLength: this.vo.itemInfoVO.goodsSpecificationInfoVO.packSizeLength,
          PackSizeWidth: this.vo.itemInfoVO.goodsSpecificationInfoVO.packSizeWidth,
          PackSizeHeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.packSizeHeight,
          PackWeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.packWeight,
          PackContainNum: this.vo.itemInfoVO.goodsSpecificationInfoVO.packContainNum,
          PackJanCode: this.vo.itemInfoVO.goodsSpecificationInfoVO.packJanCode,
          BowlSizeLength: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlSizeLength,
          BowlSizeWidth: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlSizeWidth,
          BowlSizeHeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlSizeHeight,
          BowlWeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlWeight,
          BowlContainNum: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlContainNum,
          BowlJanCode: this.vo.itemInfoVO.goodsSpecificationInfoVO.bowlJanCode,
          CaseSizeLength: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseSizeLength,
          CaseSizeWidth: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseSizeWidth,
          CaseSizeHeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseSizeHeight,
          CaseWeight: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseWeight,
          CaseContainNum: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseContainNum,
          CaseJanCode: this.vo.itemInfoVO.goodsSpecificationInfoVO.caseJanCode,
          FactoryAddress: this.vo.itemInfoVO.goodsSpecificationInfoVO.factoryAddress,
        }
      } : { };

    // 環境関連タブ情報(温暖化防止)
    const goodsDnaInfos = this.vo.pCodeInfoVO.goodsDnaInfoVO.goodsDnaList
      .filter(dnaInfo => dnaInfo.Check)
      .map(dnaInfo => ({
        condition: {
          GoodsDnaDiv: dnaInfo.DnaDiv
        }
      }));

    // 取扱媒体
    const mediumInfos = this.vo.pCodeInfoVO.goodsBaseVO.mediumList
      .map(mediumInfo => ({
        condition: {
          MediumType: mediumInfo.MediumType,
          MediumName: mediumInfo.MediumName
        }
      }));

    // タグ情報
    const tagInfos = this.vo.pCodeInfoVO.goodsTagInfoVO.tagInfo
      .map(tagInfo => ({
        condition: {
          TagGroupId: tagInfo.TagGroupId,
          TagGroupName: tagInfo.TagGroupName,
          TagId: tagInfo.TagId,
          TagName: tagInfo.TagName
        }
      }));

    const data = {};
    data[this.mode] = {
      GoodsBaseData: {
        condition: {
          PCode: this.vo.pCodeInfoVO.pCode,
          ItemCode: this.vo.itemInfoVO.itemCode,
          BuyerCode: this.vo.pCodeInfoVO.buyerCode,
          ClassDivNum: this.vo.pCodeInfoVO.classDivNum,
          ClassCode: this.vo.pCodeInfoVO.classCode,
          LargeClassCode: this.vo.pCodeInfoVO.largeClassCode,
          MiddleClassCode: this.vo.pCodeInfoVO.middleClassCode,
          SmallClassCode: this.vo.pCodeInfoVO.smallClassCodeList,
          AdmitStatus: this.vo.pCodeInfoVO.admintStatus,
          PackMaterialShowFlg: this.vo.pCodeInfoVO.packMaterialShowFlg,
          DataType: this.vo.pCodeInfoVO.dataType,
          ApplyTermStart: this.vo.pCodeInfoVO.appkyTermStart,
          ApplyTermEnd: this.vo.pCodeInfoVO.appkyTermEnd,
          GuideGoodsName: this.vo.pCodeInfoVO.guideGoodsName,
          GuideStandardName: this.vo.pCodeInfoVO.guideStandardName,
          DeliveryGoodsNameKanji: this.vo.pCodeInfoVO.goodsBaseVO.deliveryGoodsNameKanji,
          DeliveryGoodsNameKana: this.vo.pCodeInfoVO.goodsBaseVO.deliveryGoodsNameKana,
          DeliveryStandardNameKanji: this.vo.pCodeInfoVO.goodsBaseVO.deliveryStandardNameKanji,
          DeliveryStandardNameKana: this.vo.pCodeInfoVO.goodsBaseVO.deliveryStandardNameKana,
          OcrGoodsName: this.vo.pCodeInfoVO.goodsBaseVO.ocrGoodsName,
          ConsumeTaxDiv: this.vo.pCodeInfoVO.goodsBaseVO.consumeTaxDivList,
          ConsumeTaxRate: this.vo.pCodeInfoVO.goodsBaseVO.consumeTaxDivRate,
          ConsumeTaxDivWk: this.vo.pCodeInfoVO.goodsBaseVO.consumeTaxDivListWk,
          ConsumeTaxRateWk: this.vo.pCodeInfoVO.goodsBaseVO.consumeTaxDivRateWk,
          CycleTerm: this.vo.pCodeInfoVO.goodsBaseVO.cycleTerm,
          EdlpDiv: this.vo.pCodeInfoVO.goodsBaseVO.edlpDiv,
          GuideTempZoneDiv: this.vo.pCodeInfoVO.goodsBaseVO.guideTempZoneDiv,
          UnitPriceDiv: this.vo.pCodeInfoVO.goodsBaseVO.unitPriceDiv,
          UnitPriceCoefficient: this.vo.pCodeInfoVO.goodsBaseVO.unitPriceCoefficient,
          UnitPriceUnit: this.vo.pCodeInfoVO.goodsBaseVO.unitPriceUnit,
          ConsumeTerm: this.vo.pCodeInfoVO.goodsBaseVO.consumeTerm,
          ConsumeByDate: this.vo.pCodeInfoVO.goodsBaseVO.consumeByDate,
          LeaveConsumeTerm: this.vo.pCodeInfoVO.goodsBaseVO.leaveConsumeTerm,
          SeasonConsumeDiv: this.vo.pCodeInfoVO.goodsBaseVO.seasonConsumeDiv,
          SeasonConsumeTerm: this.vo.pCodeInfoVO.goodsBaseVO.seasonConsumeTerm,
          SeasonConsumeTermFrom: this.vo.pCodeInfoVO.goodsBaseVO.seasonConsumeTermFrom,
          SeasonConsumeTermTo: this.vo.pCodeInfoVO.goodsBaseVO.seasonConsumeTermTo,
          BlindDiv: this.vo.pCodeInfoVO.goodsBaseVO.blindDiv,
          EfriendsSendDiv: this.vo.pCodeInfoVO.goodsBaseVO.eFriendsSendDiv,
          EcNonDispDiv: this.vo.pCodeInfoVO.goodsBaseVO.ecNonDispDiv,
          LiquorCode: this.vo.pCodeInfoVO.goodsBaseVO.liquorCode,
          AlcoholType: this.vo.pCodeInfoVO.goodsBaseVO.alocoholType,
          ContainerForm: this.vo.pCodeInfoVO.goodsBaseVO.containerForm,
          ContainerCapacity: this.vo.pCodeInfoVO.goodsBaseVO.containerCapacity,
          StinkGoodsDiv: this.vo.pCodeInfoVO.orderDistributeVO.stinkGoodsDivList,
          SetDiv: this.vo.pCodeInfoVO.orderDistributeVO.setDivList,
          CaseSupplyDiv: this.vo.pCodeInfoVO.orderDistributeVO.caseSupplyDivList,
          LongKeepDiv: this.vo.pCodeInfoVO.orderDistributeVO.longKeepDivList,
          AssortTempDiv: this.vo.pCodeInfoVO.orderDistributeVO.assortTempdivList,
          ArrivalAreaDiv: this.vo.pCodeInfoVO.orderDistributeVO.arrivalAreaDivList,
          ArrivalGoodsTemp: this.vo.pCodeInfoVO.orderDistributeVO.arrivalGoodsTemp,
          ArrivalAdminDays: this.vo.pCodeInfoVO.orderDistributeVO.arrivalAdminDays,
          ListingGoodsName: this.vo.pCodeInfoVO.goodsListingVO.listingGoodsName,
          ExecFlag: this.vo.pCodeInfoVO.execFlag,
          GoodsDiv: this.vo.pCodeInfoVO.goodsDiv,
          DutiesFormDailyDiv: this.vo.pCodeInfoVO.orderDistributeVO.dutiesFormDailyDiv,
          FragileFlg: this.vo.pCodeInfoVO.orderDistributeVO.fragileFlg,
          CategoryCode: this.vo.pCodeInfoVO.categoryCode,
          CoopGoodsTitle: this.vo.pCodeInfoVO.goodsPageInfoVO.coopGoodsTitle,
          CoopGoodsUrl: this.vo.pCodeInfoVO.goodsPageInfoVO.coopGoodsUrl,
          PageTitle: this.vo.pCodeInfoVO.goodsPageInfoVO.pageTitle,
          PageUrl: this.vo.pCodeInfoVO.goodsPageInfoVO.pageUrl
        }
      },
      GoodsDetailData: {
        condition: {
          ItemCode: this.vo.itemInfoVO.itemCode,
          JanCode: this.vo.itemInfoVO.janCode,
          JanCodeDiv: this.vo.itemInfoVO.janCodeDiv,
          BrandType: this.vo.itemInfoVO.itemVO.brandType,
          FcmcFee: this.vo.itemInfoVO.itemVO.bundlePrice,
          SpecialOrderType: this.vo.itemInfoVO.itemVO.specialOrderTypeList,
          StockType: this.vo.itemInfoVO.itemVO.stockTypeList,
          InstallmentTimes: this.vo.itemInfoVO.itemVO.installmentTimes,
          PdPilingUpDays: this.vo.itemInfoVO.itemVO.pdPilingUpDays,
          ItfCode: this.vo.itemInfoVO.itemVO.itfCode,
          OrderUnitType: this.vo.itemInfoVO.itemVO.orderUnitType,
          PriceType: this.vo.itemInfoVO.itemVO.priceType,
          MakerPrice: this.vo.itemInfoVO.itemVO.makerPrice,
          OrderClientCode: this.vo.itemInfoVO.itemVO.orderClientCode,
          PayeeClientCode: this.vo.itemInfoVO.itemVO.payeeClientCode,
          FixContainNum: this.vo.itemInfoVO.itemVO.fixContainNum,
          SetQuantity: this.vo.itemInfoVO.itemVO.setQuantity,
          EbaseSpecCode: this.vo.itemInfoVO.specifications1VO.ebaseSpecCode,
          SpecApplyDate: this.vo.itemInfoVO.specifications1VO.specApplyDate,
          EbaseGetDate: this.vo.itemInfoVO.specifications1VO.ebaseGetDate,
          RegistCatalogRound: this.vo.itemInfoVO.specifications1VO.registCatalogRound,
          MakerName: this.vo.itemInfoVO.specifications1VO.makerName,
          MakerNamePublishType: this.vo.itemInfoVO.specifications1VO.makerNamePublishType,
          PeaceSizeLength: this.vo.itemInfoVO.specifications1VO.peaceSizeLength,
          PeaceSizeWidth: this.vo.itemInfoVO.specifications1VO.peaceSizeWidth,
          PeaceSizeHight: this.vo.itemInfoVO.specifications1VO.peaceSizeHight,
          PeaceWeight: this.vo.itemInfoVO.specifications1VO.peaceWeight,
          CaseSizeLength: this.vo.itemInfoVO.specifications1VO.caseSizeLength,
          CaseSizeWidth: this.vo.itemInfoVO.specifications1VO.caseSizeWidth,
          CaseSizeHight: this.vo.itemInfoVO.specifications1VO.caseSizeHight,
          CaseWeight: this.vo.itemInfoVO.specifications1VO.caseWeight,
          GeneRecombinationDiv: this.vo.itemInfoVO.specifications1VO.geneRecombinationDiv,
          AllergenTargetType: this.vo.itemInfoVO.specifications2VO.allergenTargetType,
          AnalysisUnit: this.vo.itemInfoVO.specifications2VO.analysisUnit,
          Calorie: this.vo.itemInfoVO.specifications2VO.calolie,
          Protein: this.vo.itemInfoVO.specifications2VO.protein,
          Lipid: this.vo.itemInfoVO.specifications2VO.lipid,
          Carbohydrate: this.vo.itemInfoVO.specifications2VO.carbohydrate,
          Sodium: this.vo.itemInfoVO.specifications2VO.sodium,
          BundlePrice: this.vo.itemInfoVO.useCoopVO.consignBundle,
          EbaseSpecCodeRev: this.vo.itemInfoVO.specifications1VO.ebaseSpecCodeRev
        }
      },
      MarkCodeList: { combination: markCodes },
      TextInfoList: { combination: textInfos },
      GoodsListingList: { combination: goodsListings },
      GoodsCoopList: { combination: goodsCoops },
      GoodsCoopWkList: { combination: goodsCoopWks },
      Specifications1List: { combination: specifications1s },
      GoodsAllergenList: { combination: goodsAllergens },
      GoodsComponentAllergenList: { combination: goodsComponentAllergens },
      GoodsEcologyList: { combination: goodsEcologys },
      GoodsGWStopList: { combination: goodsGWStops },
      ContainPackingList: { combination: containPackings },
      GoodsSpecificationInfo: goodsSpecificationInfo,
      GoodsDnaInfoList: { combination: goodsDnaInfos },
      MediumList: { combination: mediumInfos },
      TagList: { combination: tagInfos }
    };

    return new PlessRequest(data);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistGoodsService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    const serviceId = !PlessViewUtilsSub.isEmpty(this.model.pCode) ? 'updateGoods' : 'registGoods';
    this.send(serviceId, this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistGoodsService
   */
  success(data: any): void {

    // ItemCode情報を初期化する。
    this.model.kymw1100Component.clearDataItemInfo();
    this.model.kymw1100Component.clearEditCount();
    this.model.kymw1100Component.clearEbaseDataReflectionFlag();

    // サーバから貰った情報をセットする。
    this.model.registGoods(data);

    // 利用生協のチェックボックスを制御する。本登録【非活性】本登録以外【活性】
    this.model.kymw1100Component.eventCoopListEnabled();

    // 登録レベルの状態を判定するため、「registGoods」の後に実施
    this.model.kymw1100Component.setSeachButton();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }

  public plessErrorHandler(errList: any) {
    if (errList.errorcode === 'Q0124') {
      this.model.kymw1100Component.dialogService.openAlertGetMessage('Q0124', ['JANコード'],
        (closeEvent: any) => {
          if (closeEvent === PlessAlert.Yes) {
            this.model.kymw1100Component.ExecFlag = '1';
            this.model.kymw1100Component.updateGoods();
          }
        });
    } else {
      // 標準処理を続行
      super.plessErrorHandler(errList);
    }
  }

  /**
   * 利用生協タブの価格をAPIに渡すデータの取得。
   * 未入力の場合「0」を返却。
   *
   * @param string:価格
   */
  private getCoopiInfoPrice(price: string): string {
    if (PlessViewUtilsSub.isEmpty(price)) {
      return '0';
    }
    return price;
  }
}
